<app-sgke140d [isMordal]="true" [isEdit]="data.isEdit"
    [rcvmnyReconciliationresultMno]="data.rcvmnyReconciliationresultMno"
    [rcvmnyreconciliationResultUpdatesequencenumber]="data.rcvmnyreconciliationResultUpdatesequencenumber"
    [feeMno]="data.feeMno" [feeRrkno]="data.feeRrkno" [feeUpdatesequencenumber]="data.feeUpdatesequencenumber"
    (dialogCloseEmitter)="closeDialog($event)">
</app-sgke140d>